import { handle } from 'redux-pack';
import * as types from '../../../actionTypes';

export default (state, action) => {
  // NOSONAR
  const { type, payload } = action;

  switch (type) {
    case types.CPMS_FETCH_DIRECT_DEBIT_MANDATES:
      return handle(state, action, {
        start: (prevState) => ({
          ...prevState,
          directDebitMandates: {
            loading: true,
            data: null,
            error: null,
          },
        }),
        failure: (prevState) => ({
          ...prevState,
          directDebitMandates: {
            loading: false,
            data: null,
            error: payload,
          },
        }),
        success: (prevState) => ({
          ...prevState,
          directDebitMandates: {
            loading: false,
            data: payload.data,
            error: null,
          },
        }),
      });
    default:
      return state;
  }
};
